import EmporiumSecNavBar from '@src/components/navigationBar/secondary/EmporiumSecNavBar'
import OrbitalTrackThirdNavBar from '@src/components/navigationBar/third/OrbitalTrackThirdNavBar'
import OrbitalTrackMarketplace from '@src/components/orbitalTrack/list/marketplace/OrbitalTrackMarketplace'
import { useSecondaryNavBarContext } from '@src/contexts/share/SecondaryNavBarContext'
import useQueryInject from '@src/hooks/common/router/useQueryInject'
import { NextPage } from 'next'
import { useEffect } from 'react'

const DEFAULT_QUERY = { isOpenRent: true }

const OrbitingItemsPage: NextPage<Props> = () => {
  const { setupBar } = useSecondaryNavBarContext()

  const { injected: allowFetch } = useQueryInject(DEFAULT_QUERY)

  useEffect(() => {
    setupBar(<EmporiumSecNavBar index={4} />)

    return () => setupBar(null)
  }, [setupBar])

  return (
    <OrbitalTrackMarketplace
      allowFetch={allowFetch}
      thirdNavBar={<OrbitalTrackThirdNavBar index={0} />}
    />
  )
}

type Props = {}

export default OrbitingItemsPage
